export default __webpack_public_path__ + "static/fFbjopkf-59fc9ac792a76c9dbb6d86978414d403.svg";